import { render } from "./Epoch.vue?vue&type=template&id=2509849c&scoped=true"
import script from "./Epoch.vue?vue&type=script&lang=js"
export * from "./Epoch.vue?vue&type=script&lang=js"

import "./Epoch.vue?vue&type=style&index=0&id=2509849c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2509849c"]])

export default __exports__